// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VPue","toggleWrap":"styles_toggleWrap__3tV7e","content":"styles_content__jJPfK","selectAreaCode":"styles_selectAreaCode__zovyq"};